<template>
  <VueJsModalPrimary
    v-bind="getModalAttrs"
    @before-close="beforeClose"
    @before-open="beforeOpen"
  >
    <div :style="style.container">
      <HeaderLargePrimary>
        Tag Skills
      </HeaderLargePrimary>
      <div>
        <div :style="style.text">
          Tag {{ firstName }} with any missing skills.
        </div>
        <TagInputSkillPrimary
          v-model="tags"
          :caseInsensitiveExcludes="caseInsensitiveExcludes"
          :maxHeightDropdown="maxHeightDropdown"
          placeholder="Enter skill name"
        />
      </div>
      <div :style="style.bottom">
        <ButtonSecondary @click="close" >
          Cancel
        </ButtonSecondary>
        <ButtonPrimary
          :disabled="disableCoeditButton"
          @click="coeditTenantUserSkills"
        >
          Done
        </ButtonPrimary>
      </div>
    </div>
  </VueJsModalPrimary>
</template>

<script>
  import ButtonPrimary from '@modules/v2/button/button-primary'
  import ButtonSecondary from '@modules/v2/button/button-secondary'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import TagInputSkillPrimary from '@modules/v2/input/tag-input-skill-primary'
  import VueJsModalPrimary from '@modules/v2/modal/vue-js-modal-primary'
  import { Layout } from '@js/styles'
  import { mapGetters } from 'vuex'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'ModalTenantUserSkillCoedit',
    components: {
      ButtonPrimary,
      ButtonSecondary,
      HeaderLargePrimary,
      TagInputSkillPrimary,
      VueJsModalPrimary,
    },
    data: function () {
      return {
        maxHeightDropdown: '320px',
        name: MODAL_WINDOW_NAMES.CREATE_OTHER_TENANT_USER_SKILL_PRIMARY,
        tags: [],
        tenantUser: {},
        tenantUserSkills: [],
        style: {
          bottom: {
            alignItems: 'flex-end',
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          },
          container: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
            padding: Layout.space.lg,
            width: '100%',
          },
          text: {
            margin: `0 0 ${Layout.space.lg}`,
          },
        },
      };
    },
    computed: {
      caseInsensitiveExcludes: function () {
        return this.tenantUserSkills.map(elem => elem.skill.name);
      },
      disableCoeditButton: function () {
        return (
          this.tags.length === 0 ||
          this.tags.some(elem => elem.trim().length === 0)
        );
      },
      firstName: function () {
        return `${this.tenantUser?.user?.firstName}`;
      },
      getModalAttrs: function () {
        return {
          height: '274px',
          maxWidth: 480,
          name: this.name,
        };
      },
    },
    methods: {
      beforeClose: function () {
        this.clearCache();
      },
      beforeOpen: function (e) {
        this.clearCache();
        this.tenantUser = e?.params?.tenantUser;
        if (this.tenantUser === undefined || this.tenantUser === null) {
          this.$store.commit(
            'notification/setWarning',
            'Failed to load user data',
          );
          this.close();
        }

        this.tenantUserSkills = e?.params?.tenantUserSkills;
        if (this.tenantUserSkills === undefined || this.tenantUserSkills === null) {
          this.$store.commit(
            'notification/setWarning',
            'Failed to load skills data',
          );
        }
      },
      clearCache: function () {
        this.tenantUser = {};
        this.tenantUserSkills = [];
      },
      clearForm: function () {
        this.tags = [];
      },
      close: function () {
        this.$modal.hide(this.name);
      },
      coeditTenantUserSkills: function () {
        this.$emit('coedit-skills', this.tags);
      },
    },
  };
</script>
